import _ from "lodash";

export const WEEK_DAYS = [
  { name: "MON", id: 1 },
  { name: "TUE", id: 2 },
  { name: "WED", id: 3 },
  { name: "THU", id: 4 },
  { name: "FRI", id: 5 },
  { name: "SAT", id: 6 },
  { name: "SUN", id: 7 },
];

export const generateTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const formattedHour = hour?.toString().padStart(2, "0");
      const formattedMinute = minute?.toString().padStart(2, "0");
      options.push(`${formattedHour}:${formattedMinute}`);
    }
  }
  options.push("24:00");
  return options;
};

export const formatTime = (hour, minute) => {
  const formattedHour = hour?.toString().padStart(2, "0");
  const formattedMinute = minute?.toString().padStart(2, "0");
  return `${formattedHour}:${formattedMinute}`;
};

export const getSlotList = (slotTime) => {
  let slotArray = [];
  let fromTime =
    Number(slotTime["startTime"]["hour"]) * 60 +
    Number(slotTime["startTime"]["minute"]);
  let toTime =
    Number(slotTime["endTime"]["hour"]) * 60 +
    Number(slotTime["endTime"]["minute"]);

  let timeDifference = toTime - fromTime;
  let slotMultiples = timeDifference / 15;
  for (let i = 0; i < slotMultiples; i++) {
    slotArray.push(fromTime + i * 15);
  }
  return slotArray;
};

export const getTimeSlotClass = (currentTimeSlot, slotList, periodColors) => {
  let tarrifList = slotList;
  let hourFound = "transparent";
  tarrifList?.forEach((list, index) => {
    if (
      list.timeSlot &&
      _.flatten([list.timeSlot].map((slot) => getSlotList(slot))).includes(
        currentTimeSlot
      )
    ) {
      hourFound = periodColors[index];
    }
  });
  return { backgroundColor: hourFound };
};

export const getTimeSlotsClass = (currentTimeSlot, slotList, periodColors) => {
  let tarrifList = slotList;
  let hourFound = "transparent";
  tarrifList?.forEach((list, index) => {
    if (
      list.timeSlots &&
      _.flatten(list.timeSlots.map((slot) => getSlotList(slot))).includes(
        currentTimeSlot
      )
    ) {
      hourFound = list?.periodColor || periodColors[index];
    }
  });
  return { backgroundColor: hourFound };
};

export const getRandomInt = (min, max) => {
  return _.random(min, max);
};
